import "./chunk-EUXUH3YW.js";

// libs/widgets/src/lib/notifications/i18n/de.ts
var de_default = {
  "widgets.notifications.fusion-swap-view.status.pending": "Ausstehend",
  "widgets.notifications.fusion-swap-view.status.filled": "Abgeschlossen",
  "widgets.notifications.fusion-swap-view.status.false-predicate": "Gef\xFCllt",
  "widgets.notifications.fusion-swap-view.status.not-enough-balance-or-allowance": "Gef\xFCllt",
  "widgets.notifications.fusion-swap-view.status.partially-filled": "Gef\xFCllt",
  "widgets.notifications.fusion-swap-view.status.wrong-permit": "Gef\xFCllt",
  "widgets.notifications.fusion-swap-view.status.invalid-signature": "Gef\xFCllt",
  "widgets.notifications.fusion-swap-view.status.expired": "Abgelaufen",
  "widgets.notifications.fusion-swap-view.status.cancelled": "Abgebrochen",
  "widgets.notifications.fusion-swap-view.control.cancel": "Abbrechen"
};
export {
  de_default as default
};
//# sourceMappingURL=de-6LJ5U5KP.js.map
